import { Typography } from "@/components/ui";

type RepairIntakeStepProgressProps = {
  activeStep: number;
  totalSteps: number;
};

export function RepairIntakeStepProgress({ activeStep, totalSteps }: RepairIntakeStepProgressProps) {
  return (
    <div className="space-y-3">
      <Typography variant="display-xs" weight="semibold">
        Repair Intake Form
      </Typography>
      <Typography className="max-w-3xl text-gray-600">
        Complete each section in order. All fields are required unless the form explicitly marks them optional.
      </Typography>
      <div className="flex items-center justify-between gap-4">
        <Typography variant="text-small" weight="medium" className="text-gray-600">
          Step {activeStep + 1} of {totalSteps}
        </Typography>
        <div className="h-2 w-full max-w-sm overflow-hidden rounded-full bg-gray-200">
          <div
            className="h-full rounded-full bg-primary transition-all"
            style={{ width: `${((activeStep + 1) / totalSteps) * 100}%` }}
          />
        </div>
      </div>
    </div>
  );
}
